module.exports = __webpack_public_path__ + "static/media/people.bb08a9ae.svg";